// extracted by mini-css-extract-plugin
export default {"about":"About_about__K-cJI","legal":"About_legal__DYKgH","github":"About_github__4qNnh"};